/* eslint-disable no-empty */
import axios from 'axios';
import {
  SERVER_ERROR_KEY,
  handleAxiosResponse,
  handleError,
} from '@r-and-a-shared-ui/utils';

import httpErrors, { HttpError } from 'http-errors';
import { LiveEventExtendedInput } from '../input-schemas/playback-api-input-schema';
import { LiveEventExtendedResponse } from '../response-schemas/live-event-extended-response';
import { getAuthToken, getHeader } from '../utils/queries-utils';

export const LiveEventExtendedQuery = async ({
  input,
}: {
  input: LiveEventExtendedInput;
}) => {
  try {
    const {  streamId, isAuthenticated, refreshToken, accessToken, idToken, config} = input;

    const { url, xApiKey, realm } = config;

    const authToken = await getAuthToken({
      isAuthenticated,
      refreshToken,
      accessToken,
      idToken,
      config});

    const result = await axios
      .get(`${url}/api/v3/stream/event/${streamId}`,
        getHeader(xApiKey!, realm!, authToken))
      .then(handleAxiosResponse)
      .catch(handleError);

    if (result.hasErrors) {
      const err = httpErrors?.[result?.statusCode as keyof typeof httpErrors]?.(
        result?.errorMessages?.join('\n'),
      ) as HttpError;
      err.name = result.data?.value?.errorKey || SERVER_ERROR_KEY;
      throw err;
    }

    return result.data as LiveEventExtendedResponse;
    

  } catch (err: any) {
    console.error(`Error on Live Event Extended Query: ${err?.message || err}`);
    err.message = JSON.stringify(err?.name, err?.message);
    throw err;
  }
};
